/* Fransk katalog for locale-autopilot-customers.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'ap.customerFollowup.title': 'Suivi clients',
  'ap.customerFollowup.waiting': 'En attente de réponse',
  'ap.customerFollowup.ready': 'Prêt pour un devis',
  'ap.customerFollowup.document': 'Devis ou commande à suivre',
  'ap.customerFollowup.openChat': 'Ouvrir le chat',
  'ap.customerFollowup.empty': 'Aucun client ne nécessite de suivi pour le moment.',
});
